import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router";
import { connect } from "react-redux";

import { getDashboardPath, getOnboardingPath, THEMES } from "../../constants";
import * as actions from "../../store/actions";
import { getRole, getUserData } from "../../utils/localStorage";

import Header from "../Registration/Header";
import SideMenu from "./SideMenu";
import LoadingSpinner from "../../components/uiElements/loadingSpinner/LoadingSpinner";
import TopBar from "../Dashboard/TopBar";
import changeTheme from "../../utils/changeTheme";

const OnboardingLayout = ({
  children,
  location,
  apiUtil,
  redirectedPath,
  authInit,
  getDoctorDetails,
  getDoctorAppTheme,
  isAuth,
  personalInfo,
  practiceDetails,
}) => {
  const showSideContent =
    location.pathname !== getOnboardingPath("/create-profile") &&
    location.pathname !== getOnboardingPath("/profile-complete") &&
    location.pathname !== getOnboardingPath("/under-review");

  useEffect(() => {
    let theme;
    theme = THEMES.find(theme => theme.name === getUserData()?.user_theme);
    theme && changeTheme(theme);
  }, []);

  const history = useHistory();
  const userData = getUserData();

  useEffect(() => {
    if (
      getRole() === "PHYSICIAN" &&
      isAuth &&
      (!personalInfo.dataLoaded || !practiceDetails.dataLoaded)
    ) {
      userData?.id && getDoctorAppTheme();
      getDoctorDetails("init", () => {
        history.push(
          userData?.doctor_status === "PENDING"
            ? getOnboardingPath("/under-review")
            : userData?.doctor_status !== "DENIED" &&
                userData?.doctor_status !== "PROFILE_INCOMPLETE" &&
                getDashboardPath("/appointments")
        );
      });
    }
    // eslint-disable-next-line
  }, []);

  const userStatus = getUserData()?.doctor_status === "ACCEPTED";

  if (
    localStorage.getItem("loginLoading") ||
    (apiUtil.isLoading && apiUtil.show)
  ) {
    return (
      <div className="center-content">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <div className={"row mr-0"}>
        {redirectedPath && userStatus && (
          <div className={"col-md-12 p-0"}>
            <span className="position-absolute pl-3">
              <Header />
            </span>
            <span className="">
              <TopBar />
            </span>
          </div>
        )}
        <div className={showSideContent ? "col-md-6" : "col-md-12"}>
          {!redirectedPath && <Header />}
          {showSideContent && (
            <div className="d-flex flex-wrap justify-content-center mt-5">
              <SideMenu showBack={!!redirectedPath} onShowBack={authInit} />
            </div>
          )}
        </div>
        <div
          className={showSideContent ? "col-md-6" : "col-md-12"}
          style={{
            backgroundColor: showSideContent && "#F6F8FC",
            minHeight: "100vh",
          }}
        >
          {children}
        </div>
      </div>
      {apiUtil.isLoading && showSideContent && (
        <div className="center-content">
          <LoadingSpinner asOverlay={showSideContent} />
        </div>
      )}
    </>
  );
};

const mapStoreToProps = ({ api, auth, onboarding }) => ({
  apiUtil: api,
  redirectedPath: auth.redirectToOnboardingPath,
  personalInfo: onboarding.personalInfo,
  practiceDetails: onboarding.practiceDetails,
  isAuth: auth.isAuth,
});

const mapDispatchToProps = dispatch => ({
  authRedirect: () => dispatch(actions.authRedirect()),
  authInit: (path, redirect) => dispatch(actions.authInit(path, redirect)),
  getDoctorDetails: (flag, cb) => dispatch(actions.getDoctorDetails(flag, cb)),
  getDoctorAppTheme: () => dispatch(actions.getDoctorAppTheme()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(OnboardingLayout)
);
